import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { SEARCH_SUCCESS, UPDATE_COLUMN_VISIBILITY } from "../actions";
import { type TabularColumnDefDTO } from "~/features/search/models/SearchResultsDTO";
import { type ProductGroup } from "../../models/models";
import { type SearchResultData } from "~/utils/models";
import { UnitMode } from "~/domains/userPreferences/types/UnitMode";
import { toMapFn } from "~/common/utils/reducers";

export interface ConfigState {
  tabularViewColConfig: TabularColumnDefDTO[];
  tabularViewColConfigImperial: TabularColumnDefDTO[];
  fullTaxonomy: ProductGroup[];
}

export const configInitialState: ConfigState = {
  tabularViewColConfig: [],
  tabularViewColConfigImperial: [],
  fullTaxonomy: [],
};

export const configSlice = createSlice({
  name: "config",
  initialState: configInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(SEARCH_SUCCESS, (state, action: PayloadAction<{ data: SearchResultData }> | any) => {
        const { data } = action.payload;
        state.tabularViewColConfig = data.tabularViewColConfig;
        state.tabularViewColConfigImperial = data.tabularViewColConfigImperial;
        state.fullTaxonomy = data.fullTaxonomy;
      })

      .addCase(
        UPDATE_COLUMN_VISIBILITY,
        (
          state,
          action: PayloadAction<{ columnVisibility: { code: string; visible: boolean }[]; unitMode: UnitMode }> | any,
        ) => {
          const { columnVisibility, unitMode } = action.payload;

          function update(columns: TabularColumnDefDTO[]) {
            const colMap = toMapFn(columns, (i) => i.code);
            return columnVisibility.map((c: { code: string; visible: boolean }) => ({
              ...colMap[c.code],
              isVisible: c.visible,
            }));
          }

          if (unitMode === UnitMode.Imperial) {
            state.tabularViewColConfigImperial = update(state.tabularViewColConfigImperial);
          } else {
            state.tabularViewColConfig = update(state.tabularViewColConfig);
          }
        },
      );
  },
});

export const configReducer = configSlice.reducer;
